import { TextComponentFieldsFragment, TextComponentInput } from '@anyx/common-graphql';

import { StyledTextInputComponent } from '../../components';

import { plainTextToLexicalState } from './utils';

type StyledTextInputAdapter = {
  toGQL: (input: StyledTextInputComponent) => TextComponentInput;
  toMessageBlock: (input: TextComponentFieldsFragment) => StyledTextInputComponent;
};

export const styledTextInputAdapter: StyledTextInputAdapter = {
  toGQL: ({ text, richText, align, fontSize, weighted }) => ({
    align,
    fontSize,
    richText,
    text,
    weighted,
  }),
  toMessageBlock: ({ text, richText, align, fontSize, weighted }) => ({
    align: align || 'start', //TODO: remove this default value when align is updated to required
    fontSize,
    weighted,
    text,
    richText: richText || plainTextToLexicalState(text),
  }),
};
